// extracted by mini-css-extract-plugin
export var actionText = "_md-4";
export var container = "_md-0";
export var leftSection = "_md-1";
export var rightSection = "_md-2";
export var settingsButton = "_md-6";
export var settingsIcon = "_md-7";
export var shortcut = "_md-5";
export var shortcutGroup = "_md-3";